module.exports = __webpack_public_path__ + "static/media/o-continuum-sample.7df84a95.png";